module.exports = __webpack_public_path__ + "static/media/d.14eb78cc.svg";